import Vue from 'vue'
import VueI18n from 'vue-i18n'
//import english from '@/lang/english.js'
//import russian from '@/lang/russian.js'

Vue.use(VueI18n)

let messages = {
    //en : english,
    //ru : russian,
    ru: {
        task: 'нет задач | {n} задача | {n} задачи | {n} задач',
        car: '0 машин | {n} машина | {n} машины | {n} машин',
        banana: 'нет бананов | {n} банан | {n} банана | {n} бананов',
        day: '0 дней | {n} день | {n} дня | {n} дней',
        statement: '0 выписок | {n} выписка | {n} выписки | {n} выписок',
        adult: 'нет взрослых | {n} взрослый | {n} взрослых | {n} взрослых',
        child: 'нет детей | {n} ребенок | {n} детей | {n} детей',
        room: 'нет номеров | {n} номер | {n} номера | {n} номеров',
        order: 'нет заявок | {n} заявка | {n} заявки | {n} заявок',
    }
}

/**
 * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
 * @param choicesLength {number} an overall amount of available choices
 * @returns a final choice index to select plural word by
 **/
VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
    // this === VueI18n instance, so the locale property also exists here
    if (this.locale !== 'ru') {
        // proceed to the default implementation
    }

    if (choice === 0) {
        return 0;
    }

    const teen = choice > 10 && choice < 20;
    const endsWithOne = choice % 10 === 1;

    if (!teen && endsWithOne) {
        return 1;
    }

    if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
    }

    return (choicesLength < 4) ? 2 : 3;
}

export default new VueI18n({
    //locale: 'ru',
    locale: window.localStorage.Language || 'ru',

    fallbackLocale: 'ru',
    messages
})
